import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TabsState {
    [pageKey: string]: string;
}

const initialState: TabsState = {};

const tabsSlice = createSlice({
    name: 'tabs',
    initialState,
    reducers: {
        setTab: (state, action: PayloadAction<{ page: string; value: string }>) => {
            state[action.payload.page] = action.payload.value;
        },
    },
});

export const { setTab } = tabsSlice.actions;
export default tabsSlice.reducer;
